import _assign from "object-assign";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useContext, forwardRef } from 'react';
import { withStyles } from '@jpmuitk/theme';
import { Button } from '@jpmuitk/button';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import ButtonBarContext from './internal/ButtonBarContext';
import useDescendant from './internal/useDescendant';
import { orderedButtonStyle } from './orderedButtonStyle';

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var OrderedButton = /*#__PURE__*/forwardRef(function OrderedButton(_ref, ref) {
  var _classnames;

  var className = _ref.className,
      classes = _ref.classes,
      alignProp = _ref.align,
      densityProp = _ref.density,
      order = _ref.order,
      alignLeftOrder = _ref.alignLeftOrder,
      stackOrder = _ref.stackOrder,
      variant = _ref.variant,
      restProps = _objectWithoutProperties(_ref, ["className", "classes", "align", "density", "order", "alignLeftOrder", "stackOrder", "variant"]);

  var index = useDescendant({
    order: order,
    stackOrder: stackOrder,
    alignLeftOrder: alignLeftOrder,
    variant: variant
  });

  var _useContext = useContext(ButtonBarContext),
      matches = _useContext.matches,
      densityContext = _useContext.density,
      alignContext = _useContext.align,
      alignedIndex = _useContext.alignedIndex;

  var density = densityProp || densityContext;
  var alignFromParent = index === alignedIndex ? alignContext : undefined;
  var align = alignProp || alignFromParent;
  return /*#__PURE__*/React.createElement(Button, _assign({
    className: classnames(classes.orderedButton, classes["".concat(density, "Density")], (_classnames = {}, _defineProperty(_classnames, classes["align".concat(align ? capitalize(align) : '')], align && !matches), _defineProperty(_classnames, classes.stacked, matches), _classnames), className),
    density: density,
    ref: ref,
    variant: variant
  }, restProps));
});
process.env.NODE_ENV !== "production" ? OrderedButton.propTypes = {
  /**
   * Aligns the button (and any buttons before/after) it on the left/right
   * of the container
   */
  align: PropTypes.oneOf(['left', 'right']),

  /**
   * The order the button will be rendered when NOT stacked and the button bar is aligned left order.
   * Buttons are ordered in descending order by default and then by their source order.
   * This defaults to 1 for `CTA`, 2 for `regular` and 0 for `secondary`
   */
  alignLeftOrder: PropTypes.number,

  /**
   * The className(s) of the component
   */
  className: PropTypes.string,

  /**
   * @external - material-ui
   */
  classes: PropTypes.objectOf(PropTypes.string),

  /**
   * Density of the DialogActionButtons
   */
  density: PropTypes.oneOf(['touch', 'low', 'medium', 'high']),

  /**
   * The order the button will be rendered when NOT stacked. Buttons are ordered
   * in descending order by default and then by their source order.
   * This defaults to 0 for `CTA`, 1 for `regular` and 2 for `secondary`
   */
  order: PropTypes.number,

  /**
   * The order the button will be rendered when stacked. Buttons are ordered
   * in descending order by default and then by their source order.
   * This defaults to 2 for `CTA`, 1 for `regular` and 0 for `secondary`
   */
  stackOrder: PropTypes.number
} : void 0;
export default withStyles(orderedButtonStyle, {
  name: 'OrderedButton'
})(OrderedButton);